import { createSelectorHooks } from "auto-zustand-selectors-hook";
import { produce } from "immer";
import { create } from "zustand";

export interface payloadModal {
  show: boolean;
  title: string | null;
  body: string | null;
  onClickOK?: any;
  type?: "success" | "error" | null;  
}

interface IModalResult extends payloadModal {
  modalResultSet: (val: payloadModal) => void;
}

const useModalResult = create<IModalResult>((set) => ({
  show: false,
  title: "",
  body: "",
  onClickOK: () => null,
  modalResultSet: (val) => {
    set(
      produce<payloadModal>((state) => {
        state.show = val.show;
        state.title = val.title;
        state.body = val.body;
        state.onClickOK = val.onClickOK;
        state.type = val.type
      }),
    );
  },
}));

const useModalResultStore = createSelectorHooks(useModalResult);

export default useModalResultStore;
